<template>

    <router-view></router-view>

</template>


<script>
export default {
  name: "MaterialModule",
  components: {},
  data: () => ({}),
};
</script>
